import Layout from 'layouts/Default'
import {
  StyledBoxContainerContent as ContainerContent,
  StyledBoxContainerTitle as ContainerTitle,
} from './styles'
import {
  Box,
  Button,
  Grid,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material'
import Label from 'components/Label'
import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import BalanceIcon from '@mui/icons-material/Balance'
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import { usePendingProcessHearing } from 'pages/PendingProcessHearing/hook/pending-process-hearing.hook'
import { StyledCardStatus } from 'pages/PendingProcessHearing/styles'
import { getStatusBackgroundColor } from 'pages/PendingProcessHearing'
import { TeenagerProcessHearingType } from 'types/teenager-process-hearing.type'
import { FormProvider, useFieldArray, useForm } from 'react-hook-form'
import {
  PendingProcessHearingSchema,
  PendingProcessHearingType,
  PendingProcessHearingTypeDefaultValues,
} from 'types/pending-process-hearing.type'
import { zodResolver } from '@hookform/resolvers/zod'
import FormInput from 'components/FormInput'
import SaveRoundedIcon from '@mui/icons-material/SaveRounded'
import { TableHeadCell } from 'pages/SearchTeenager/styles'
import TableCell from '@mui/material/TableCell'
import { cnjMask } from 'utils/mask.util'
import { useAuthContext } from 'contexts/auth.context'
import { Funcionalidades } from 'utils/helpers/funcionalidades'
import WarningIcon from '@mui/icons-material/Warning'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { EditarStatusModal } from 'pages/ViewPendingProcessHearing/modal/EditarStatusModal'
import {
  AdolescenteIntegraJudicialType,
  AdolescentesIntegraJudicialModal,
} from 'pages/ViewPendingProcessHearing/modal/AdolescentesIntegraJudicialModal'
import { ViewPendingProcessHearingHeader } from 'pages/ViewPendingProcessHearing/components/ViewPendingProcessHearingHeader'

export const STATUS_OPTIONS: any = {
  PENDENTE: 'Pendente',
  AGENDADO: 'Agendado',
  NAO_REALIZADO: 'Não Realizado',
  FINALIZADO: 'Finalizado',
}

export const MOTIVO_OPTIONS: any = {
  HOSPITALIZADO: 'Adolescente hospitalizado',
  NAO_ENCONTRADO: 'Adolescente não encontrado',
  OUTROS: 'Outro',
}

const ViewPendingProcessHearing = () => {
  const { handleHasPermission } = useAuthContext()
  const { pendingProcessHearingId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const { state } = location

  const [locationState, setLocationState] = useState<{
    promotoria: string
  }>()

  const form = useForm<PendingProcessHearingType>({
    mode: 'all',
    resolver: zodResolver(PendingProcessHearingSchema),
    defaultValues: PendingProcessHearingTypeDefaultValues,
  })

  const {
    control,
    handleSubmit,
    reset,
    formState: { isDirty, dirtyFields },
  } = form

  const hasDirtyFields = Object.keys(dirtyFields).length > 0 && dirtyFields.constructor === Object

  const { fields, append, update, remove } = useFieldArray<
    PendingProcessHearingType,
    'adolescentes',
    '_id'
  >({
    control,
    name: 'adolescentes',
    keyName: '_id',
  })

  const {
    processo,
    handleBuscarPorId,
    handleSalvar,
    handleNovaOitiva,
    disableIniciarOitiva,
    disableInformarStatusOitiva,
  } = usePendingProcessHearing()

  const handleChangeAdolescenteStatus = async (
    index?: number | null,
    props?: TeenagerProcessHearingType,
  ) => {
    if (props && index !== null && index !== undefined) {
      update(index, props)
    }
  }

  useEffect(() => {
    if (state) {
      const locationState = state as {
        promotoria: string
      }

      setLocationState(locationState)
    }
  }, [state])

  useEffect(() => {
    ;(async () => {
      console.log('teste')
      if (pendingProcessHearingId) {
        await handleBuscarPorId(pendingProcessHearingId)
      }
    })()
  }, [pendingProcessHearingId])

  useEffect(() => {
    reset(processo)
  }, [processo])

  const adicionarAdolescentesIntegraJudicial = async (data: AdolescenteIntegraJudicialType[]) => {
    const nomesExistentes = fields.map((item) => item.nomeAdolescente)
    const novosItens: TeenagerProcessHearingType[] = data
      .filter((item) => item.nomeAdolescente && !nomesExistentes.includes(item.nomeAdolescente))
      .map((item) => ({
        nomeAdolescente: item.nomeAdolescente || '',
        status: 'PENDENTE',
        indicadorIntegracao: 'S',
      }))

    append(novosItens)
  }

  const handleSalvarAdolescentes = async (props: PendingProcessHearingType) => {
    console.log('handleSalvarAdolescentes')
    if (pendingProcessHearingId) {
      await handleSalvar(pendingProcessHearingId, props)
      await handleBuscarPorId(pendingProcessHearingId)
    }
  }

  return (
    <Layout>
      <FormProvider {...form}>
        <form onSubmit={handleSubmit(handleSalvarAdolescentes)}>
          {processo && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <ContainerTitle>
                  <Label text='VISUALIZAR PROCESSO PENDENTE DE OITIVA' v='h6' bold />
                </ContainerTitle>
                <ContainerContent>
                  <ViewPendingProcessHearingHeader
                    processo={processo}
                    append={append}
                    onAdd={adicionarAdolescentesIntegraJudicial}
                  />
                </ContainerContent>
              </Grid>
              <Grid item xs={12}>
                <Stack direction={'column'} spacing={1}>
                  <Typography variant={'body1'}>
                    <b>Número CNJ: </b>
                    {processo.numeroCnj && cnjMask(processo?.numeroCnj)}
                  </Typography>
                  <Typography variant={'body1'}>
                    <b>Data de Recebimento: </b>
                    {dayjs(processo.dataRecebimento).format('DD/MM/YYYY')}
                  </Typography>
                  <Typography variant={'body1'}>
                    <b>Delegacia de Circunscrição do Fato: </b>
                    {processo.delegaciaCircunscricaoFato}
                  </Typography>
                  <Typography variant={'body1'}>
                    <b>Nome da Vara: </b>
                    {processo.nomeVara}
                  </Typography>
                  <Typography variant={'body1'}>
                    <b>Nome da Comarca: </b>
                    {processo.nomeComarca}
                  </Typography>
                  <Typography variant={'body1'}>
                    <b>Tipo de Delito: </b>
                    {processo.tipoDelito}
                  </Typography>
                  <Typography variant={'body1'}>
                    <b>Descrição do Município: </b>
                    {processo.descricaoMunicipio}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} />
              {fields.length > 0 && (
                <Grid item xs={12}>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableHeadCell sx={{ maxWidth: 400 }}>Nome do adolescente</TableHeadCell>
                          <TableHeadCell align='center'>Status</TableHeadCell>
                          <TableHeadCell align='center' width={25}></TableHeadCell>
                          <TableHeadCell align='center'></TableHeadCell>
                          <TableHeadCell align='center'></TableHeadCell>
                          <TableHeadCell align='center'>Ações</TableHeadCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {fields &&
                          fields.map((field, index) => (
                            <TableRow hover key={field.id}>
                              <TableCell>
                                <Box display={'flex'} alignItems={'center'}>
                                  {!field.id ? (
                                    <FormInput
                                      name={`adolescentes.${index}.nomeAdolescente`}
                                      control={control}
                                    />
                                  ) : (
                                    <b>{field.nomeAdolescente}</b>
                                  )}
                                  {field.indicadorIntegracao === 'S' && (
                                    <Link
                                      to='https://integra.mprj.mp.br/#!/inicial'
                                      target='_blank'
                                      style={{ marginLeft: '0.75rem' }}
                                    >
                                      <Tooltip
                                        title={'Adolescente adicionado pelo Integra Judicial'}
                                      >
                                        <IconButton>
                                          <BalanceIcon color={'secondary'} fontSize='medium' />
                                        </IconButton>
                                      </Tooltip>
                                    </Link>
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell align='center'>
                                <StyledCardStatus
                                  sx={{
                                    backgroundColor: getStatusBackgroundColor(field.status),
                                  }}
                                >
                                  <small>
                                    <b>{STATUS_OPTIONS[field.status]}</b>
                                  </small>
                                </StyledCardStatus>
                              </TableCell>
                              <TableCell align='center' width={25}>
                                {field.notificacoes && field.notificacoes.length > 0 && (
                                  <Tooltip
                                    title={
                                      <div>
                                        {field.notificacoes.map((notificaco, i) => (
                                          <div key={i}>{notificaco}</div>
                                        ))}
                                      </div>
                                    }
                                  >
                                    <WarningIcon sx={{ color: '#fbc02d' }} />
                                  </Tooltip>
                                )}
                              </TableCell>
                              <TableCell align='center'>
                                <Box display={'flex'} flexDirection={'column'}>
                                  {field.status === 'AGENDADO' && (
                                    <span>{`Data do Agendamento: ${
                                      dayjs(field.dataAgendamento).isValid()
                                        ? dayjs(field.dataAgendamento).format('DD/MM/YYYY')
                                        : 'Não informado.'
                                    }`}</span>
                                  )}

                                  {field.status === 'NAO_REALIZADO' && field.motivo && (
                                    <span>{MOTIVO_OPTIONS[field.motivo]}</span>
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell align='center'>{field.justificativa}</TableCell>
                              <TableCell align='center'>
                                <Box display={'inline-flex'}>
                                  <EditarStatusModal
                                    onHasPermission={handleHasPermission}
                                    onChangeAdolescenteStatus={handleChangeAdolescenteStatus}
                                    index={index}
                                    adolescente={field}
                                    disabled={disableInformarStatusOitiva(field)}
                                  />
                                  {handleHasPermission(Funcionalidades.oitiva.visualizar) &&
                                    field.status === 'FINALIZADO' && (
                                      <Tooltip
                                        title='Visualizar resumo da oitiva.'
                                        placement={'top'}
                                      >
                                        <IconButton
                                          size='medium'
                                          onClick={async () => {
                                            let idOitiva = field.oitiva?.id
                                            if (!idOitiva) {
                                              idOitiva = await handleNovaOitiva()

                                              update(index, { ...field, oitiva: { id: idOitiva } })

                                              await handleSubmit(async (data) => {
                                                await handleSalvarAdolescentes(data)
                                              })()
                                            }

                                            if (processo) {
                                              const { numeroCnj, numeroProcesso, categoria } =
                                                processo

                                              navigate(`/visualizar-resumo-oitiva/${idOitiva}`, {
                                                state: {
                                                  numeroCnj,
                                                  numeroAAAPAI:
                                                    categoria === 'AAAPAI' ? numeroProcesso : null,
                                                  numeroAIAIBOC:
                                                    categoria !== 'AAAPAI' ? numeroProcesso : null,
                                                  promotoria: locationState?.promotoria,
                                                },
                                              })
                                            }
                                          }}
                                        >
                                          <VisibilityIcon fontSize='inherit' />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  {handleHasPermission(
                                    Funcionalidades.integraPolicial.adolescente.iniciarOitiva,
                                  ) &&
                                    field.status !== 'FINALIZADO' && (
                                      <Tooltip title='Iniciar Oitiva.' placement={'top'}>
                                        <IconButton
                                          size='medium'
                                          disabled={disableIniciarOitiva(field)}
                                          onClick={async () => {
                                            let idOitiva = field.oitiva?.id
                                            if (!idOitiva) {
                                              idOitiva = await handleNovaOitiva()

                                              update(index, { ...field, oitiva: { id: idOitiva } })

                                              await handleSubmit(async (data) => {
                                                await handleSalvarAdolescentes(data)
                                              })()
                                            }

                                            if (processo) {
                                              const { numeroCnj, numeroProcesso, categoria } =
                                                processo

                                              navigate(`/nova-oitiva/${idOitiva}/dados-gerais`, {
                                                state: {
                                                  numeroCnj,
                                                  numeroAAAPAI:
                                                    categoria === 'AAAPAI' ? numeroProcesso : null,
                                                  numeroAIAIBOC:
                                                    categoria !== 'AAAPAI' ? numeroProcesso : null,
                                                  promotoria: locationState?.promotoria,
                                                },
                                              })
                                            }
                                          }}
                                        >
                                          <PlayCircleOutlineIcon fontSize='inherit' />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  {handleHasPermission(
                                    Funcionalidades.integraPolicial.adolescente.excluir,
                                  ) && (
                                    <Tooltip title='Excluir.' placement={'top'}>
                                      <IconButton
                                        size='medium'
                                        disabled={!['PENDENTE'].includes(field.status)}
                                        onClick={() => {
                                          remove(index)
                                        }}
                                      >
                                        <DeleteOutlineRoundedIcon
                                          color={field.status === 'PENDENTE' ? 'error' : 'disabled'}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              )}
              <Grid item xs={12}>
                <Stack direction={'row'} spacing={2}>
                  <Button
                    variant={'outlined'}
                    size={'large'}
                    color={'secondary'}
                    startIcon={<ArrowBackIcon />}
                    onClick={() => {
                      navigate('/processos-pendentes')
                    }}
                  >
                    Voltar
                  </Button>
                  {handleHasPermission(Funcionalidades.integraPolicial.editar) && (
                    <Button
                      type='submit'
                      variant='contained'
                      startIcon={<SaveRoundedIcon />}
                      color='secondary'
                      sx={{ pl: 2, pr: 2 }}
                      disabled={!(isDirty && hasDirtyFields)}
                    >
                      Salvar
                    </Button>
                  )}
                </Stack>
              </Grid>
            </Grid>
          )}
        </form>
      </FormProvider>
    </Layout>
  )
}

export default ViewPendingProcessHearing
